import { Link } from "react-router-dom";
import Translated from "./../Translated";

const ShopDeliveryTermsNote = (props) => {
  return (
    <div className={props.className}>
      <Link to="/cancelling-terms">
        <Translated translationKey="delivery_terms_label" />
      </Link>
    </div>
  );
};

export default ShopDeliveryTermsNote;
